export type Category = {
  id: number;
  name: string;
  priority: number;
};
export async function fetchCategories(): Promise<Category[]> {
  const res = await fetch("/api/category/getAll", {
    method: "GET",
    cache: "no-store",
  });
  if (!res.ok) throw new Error(`List failed (${res.status})`);
  const data = await res.json();
  return Array.isArray(data?.categories) ? data.categories : data;
}

export async function createCategory(payload: {
  name: string;
  priority: number;
}): Promise<Category> {
  const res = await fetch("/api/category/create", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Create failed (${res.status})`);
  const data = await res.json();
  return data?.category ?? data;
}

export async function updateCategory(
  id: number,
  payload: { name: string; priority: number },
): Promise<Category> {
  const res = await fetch(`/api/category/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Update failed (${res.status})`);
  const data = await res.json();
  return data?.category ?? data;
}

export async function deleteCategory(id: number): Promise<void> {
  const res = await fetch(`/api/category/${id}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error(`Delete failed (${res.status})`);
}
